export const code = [
  {
    id: "purpose",
    type: "dropdown",
    choices: [
      "Troubleshoot an error",
      "Write new code (function, class, algorithm)",
      "Optimize existing code (performance, readability)",
      "Explain code functionality",
      "Generate code documentation",
      "Translate code to another language",
    ],
    template: "I want to {{value}}.",
  },
  {
    id: "language",
    type: "dropdown",
    choices: ["Python", "JavaScript", "C++", "Java", "Go"],
    template: "* The code is written in {{value}}.",
    allowOther: true,
    onChange: (value, fields) => {
      const frameworkField = fields.find((o) => o.id === "framework");
      const codeStyleField = fields.find((o) => o.id === "codeStyle");

      switch (value) {
        case "JavaScript":
          frameworkField.choices = [
            "React",
            "Angular",
            "Vue",
            "Node.js",
            "Express",
          ];
          codeStyleField.choices = ["Google Style Guide", "Airbnb Style Guide"];
          break;
        case "Python":
          frameworkField.choices = ["Django", "Flask", "PyTorch", "TensorFlow"];
          codeStyleField.choices = ["PEP 8"];
          break;
        case "Java":
          frameworkField.choices = ["Spring"];
          codeStyleField.choices = [];
          break;
        case "C#":
          frameworkField.choices = [".NET"];
          codeStyleField.choices = [];
          break;
        default:
          frameworkField.choices = [];
          codeStyleField.choices = [];
      }

      return { framework: frameworkField, codeStyle: codeStyleField };
    },
  },
  {
    id: "framework",
    type: "dropdown",
    choices: [], // This will be dynamically populated
    template: "* I'm using the {{value}} framework.",
    allowOther: true,
    conditional: (selectedFields) =>
      selectedFields.language && selectedFields.language !== "",
  },
  {
    id: "codeStyle",
    type: "dropdown",
    choices: [], // This will be dynamically populated
    template: "* I'm following the {{value}} style guide.",
    allowOther: true,
    conditional: (selectedFields) =>
      selectedFields.language && selectedFields.language !== "",
    optional: true,
  },
  {
    id: "errorMessage",
    type: "textarea",
    placeholder: "Paste error messages or logs here",
    template: "* Here's the error message I'm getting: \n```\n{{value}}\n```",
    conditional: (selectedFields) =>
      selectedFields.purpose === "Troubleshoot an error",
  },
  {
    id: "desiredInput",
    type: "textarea",
    placeholder: "Describe the expected input variables of the code",
    template: "* The desired output input variables are:\n{{value}}",
    optional: true,
  },
  {
    id: "desiredOutput",
    type: "textarea",
    placeholder: "Describe the expected outcome or behavior of the code",
    template: "* The desired output or behavior is:\n{{value}}",
    optional: true,
  },
  {
    id: "additionalContext",
    type: "textarea",
    placeholder:
      "Provide any relevant code snippets, project requirements, or specific instructions",
    template: "* Additional context: \n***\n{{value}}\n***",
    optional: true,
  },
];
